<template>
    <vs-row vs-justify="center" vs-align="center" class="full-height login-register-bg">
        <vs-col type="flex" vs-justify="center" vs-align="center" class="login-register-box" vs-lg="12" vs-xs="12">
            <vs-card class="mb-0">
                <div slot="header">
                  <h3 class="mb-1">We are checking your code</h3>
                  <p class="mb-0">Please wait for a while...</p>
                </div>

                <div slot="footer">
                    <vs-row vs-justify="flex-end">
                      <vs-button @click="close" type="gradient" color="danger" icon="close">Close</vs-button>
                    </vs-row>
                </div>
            </vs-card>
        </vs-col>
    </vs-row>
</template>

<script>
    import {AuthService} from "../../services/auth.service";
    import NProgress from 'nprogress';

    export default {
        name: 'Confirm',
        created() {
            NProgress.start();
            AuthService.makeConfirm(this.$route.params.token)
                .then( () => {
                    this.$vs.notify({
                        color: "success",
                        title: 'Success!',
                        text: 'Authorized successfully'
                    });

                    this.$store.dispatch('user/GET')
                      .then(() => this.$router.push('/'))
                      .catch( error => {
                          NProgress.done();
                          error.alert()
                      });
                })
                .catch( error => {
                    error.alert();
                    NProgress.done();
                    this.close();
                });
        },
        methods:{
            close() {
                this.$router.push({name:'register'});
            }
        }
    }
</script>

<style>
    .login-register-bg{
        margin:0 auto;
        background:url(../../assets/images/background/auth-bg.jpg) no-repeat center center;
    }
    .login-register-box{
        max-width:400px;
    }

</style>
